// Only use on trusted text
// We need this because some course descriptions contain stuff like <b>something</b>
export default function (text) {
  const html = text
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || div.innerText || ''
}
